import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "scm-error-log" }
const _hoisted_2 = { class: "table-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_app_page = _resolveComponent("app-page")!
  const _component_warehouse_info_dialog = _resolveComponent("warehouse-info-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_page, null, {
      fheader: _withCtx(() => [
        (_ctx.$has(_ctx.permissionConfig.CREATE))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "default",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.warehouseModel('add')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 新增 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      main: _withCtx(({
          height
        }) => [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            height: height,
            key: height,
            data: _ctx.tableData,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "仓库名称",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "仓库地址",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.province) + _toDisplayString(row.city) + _toDisplayString(row.area) + _toDisplayString(row.address), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "操作",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (_ctx.$has(_ctx.permissionConfig.UPDATE))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        size: "default",
                        onClick: ($event: any) => (_ctx.warehouseModel('edit', row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 修改 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.$has(_ctx.permissionConfig.DELETE))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "danger",
                        size: "default",
                        onClick: ($event: any) => (_ctx.deleteWarehouseItem(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 删除 ")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["height", "data"])), [
            [_directive_loading, _ctx.tableLoading]
          ])
        ])
      ]),
      ffooter: _withCtx(() => [
        _createVNode(_component_el_row, {
          style: {"width":"100%"},
          type: "flex",
          justify: "end"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_pagination, {
              total: _ctx.tableTotal,
              "current-page": _ctx.params.pageNum,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["total", "current-page", "onSizeChange", "onCurrentChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_warehouse_info_dialog, {
      warehouseInfoDialogVisible: _ctx.warehouseInfoDialogVisible,
      "onUpdate:warehouseInfoDialogVisible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.warehouseInfoDialogVisible) = $event)),
      rowItem: _ctx.rowItem,
      type: _ctx.warehouseType,
      onUploadList: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleSearch(_ctx.params.pageNum)))
    }, null, 8, ["warehouseInfoDialogVisible", "rowItem", "type"])
  ]))
}